<template>
  <div id="team_type">
    <div class="con_all" v-if="$route.meta.keepAliveSub2">
      <div class="con_box2">
        <div @click="selectTeam(teamitem)" v-for="(teamitem,index) in teams" :key="index" v-if="teamitem.type == teamtypeId" style="cursor:pointer">
          <div class="box2">
            <div class="class_box">
              <div class="class_pic1" :style="{backgroundImage: 'url(' + teamitem.coverPictureUrl + ')'}">
                <div class="class_title">{{showName(teamitem)}}</div>
              </div>
              <div class="fix"></div>
            </div>
          </div>
        </div>
        <div class="fix"></div>
      </div>
    </div>
    <router-view :teams="teams"></router-view>
  </div>
</template>
<script>
import axios from 'axios';
import { API, Message } from '@/assets/project_setting/config';
import { GetErrorHandler, ShowMessage } from '@/assets/library/axiosErrorHandler';


export default {
  name: 'team_type',
  props: ['teams'],
  data() {
    return {
      teamtypeId: this.$route.params.teamtypeid,
    };
  },
  created() {

  },
  methods: {
    selectTeam(team) {
      this.$router.push({ name: 'team_info', params: { teamid: team.id } });
    },

    showName(teamitem) {
      let name = {'CH': teamitem.nameCh, 'EN': teamitem.nameEn}
      return name[sessionStorage.locale];
    },
  },
}

</script>
<style lang="scss">


</style>



// WEBPACK FOOTER //
// TeamType.vue?05a3f980